import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from 'antd';
import { Icon } from 'components/Icon';

import { FullWidthSpace, RoundedCard } from 'components';
import { StyledTitle } from 'components/StyledTitle';

import { OtherPaymentMethods } from '../otherPaymentMethods/OtherPaymentMethods';
// import { SecondaryInfoText } from './SecondaryInfoText';
// import { PaymentActions } from '../paymentActions/PaymentActions';
import { getSettleAmount } from '../utils';
import { SettleItem } from '../types';
import styled from 'styled-components';

const { Text } = Typography;

interface SettleContentProps {
  claims: SettleItem[];
}
const SecondaryDiv = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: baseline;
  gap: 0.5em;
  font-size: 14px;
  color: var(--text-color-secondary) !important;
`;

export const SettleContent = ({ claims }: SettleContentProps): JSX.Element => {
  const { t } = useTranslation();
  const { currency, totalAmount } = getSettleAmount(claims);
  console.log('SettleContent claims', claims);
  return (
    <FullWidthSpace direction="vertical" size="middle">
      <RoundedCard bordered={false} title={t('claimDetails.shortfall.amount')}>
        {claims.map(
          ({ claimId, sequenceNo, osShortfallAmount, shortfallFlag }) =>
            shortfallFlag != 'Y' && (
              <Fragment key={`${claimId}-${sequenceNo}`}>
                <Text type={'secondary'}>
                  {t('shortfallPayment.claimNo')} {claimId}-{sequenceNo}
                </Text>

                <StyledTitle level={5}>
                  {osShortfallAmount?.currency} {osShortfallAmount?.amount}
                </StyledTitle>

                <br></br>
              </Fragment>
            ),
        )}

        <Text type={'secondary'}>{t('shortfallPayment.totalAmount')}</Text>

        <StyledTitle level={4}>
          {currency} {totalAmount}
        </StyledTitle>
      </RoundedCard>
      {/* <SecondaryInfoText content={t('shortfallPayment.info')} /> */}
      <SecondaryDiv>
        <Icon name="Info" width={14} style={{ top: 2, position: 'relative', flexShrink: 0 }} />
        <ul style={{ marginLeft: '16px' }}>
          <li>{t('shortfallPayment.authorized')}</li>
          {/* <li>{t('shortfallPayment.info')}</li> */}
        </ul>
      </SecondaryDiv>

      {/* <PaymentActions claims={claims} /> */}

      <OtherPaymentMethods amount={totalAmount.toFixed(2) + ''} claims={claims} />
    </FullWidthSpace>
  );
};
